const CUSTOMER_DISPLAY_CHANNEL_NAME = 'customer_display'
const CUSTOMER_DISPLAY_TAB_ID_STORAGE_KEY = 'customerDisplayTabId'
const CUSTOMER_DISPLAY_OWNER_TAB_ID_STORAGE_KEY = 'customerDisplayOwnerTabId'
const CUSTOMER_DISPLAY_OWNER_TAB_ID_QUERY_PARAM = 'ownerTabId'
export const CUSTOMER_DISPLAY_MESSAGE_SOURCE = 'customerDisplay'

const createFallbackId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2)}`

export const getCustomerDisplayTabId = () => {
  if (typeof globalThis.sessionStorage === 'undefined') {
    return createFallbackId()
  }

  const storedTabId = globalThis.sessionStorage.getItem(
    CUSTOMER_DISPLAY_TAB_ID_STORAGE_KEY
  )

  if (storedTabId) return storedTabId

  const tabId = globalThis.crypto?.randomUUID?.() || createFallbackId()
  globalThis.sessionStorage.setItem(CUSTOMER_DISPLAY_TAB_ID_STORAGE_KEY, tabId)

  return tabId
}

export const createCustomerDisplayChannel = () => {
  if (typeof BroadcastChannel === 'undefined') return null

  return new BroadcastChannel(CUSTOMER_DISPLAY_CHANNEL_NAME)
}

export const getCustomerDisplayOwnerTabId = () =>
  globalThis.localStorage?.getItem(CUSTOMER_DISPLAY_OWNER_TAB_ID_STORAGE_KEY) ||
  null

export const getCustomerDisplayOwnerTabIdFromUrl = () => {
  try {
    return new URL(globalThis.location.href).searchParams.get(
      CUSTOMER_DISPLAY_OWNER_TAB_ID_QUERY_PARAM
    )
  } catch {
    return null
  }
}

export const setCustomerDisplayOwnerTabIdInUrl = (url, ownerTabId) => {
  if (!ownerTabId) return url

  const parsedUrl = new URL(url, globalThis.location.origin)
  parsedUrl.searchParams.set(
    CUSTOMER_DISPLAY_OWNER_TAB_ID_QUERY_PARAM,
    ownerTabId
  )

  return parsedUrl.toString()
}

export const setCustomerDisplayOwnerTabId = (
  tabId = getCustomerDisplayTabId()
) => {
  globalThis.localStorage?.setItem(
    CUSTOMER_DISPLAY_OWNER_TAB_ID_STORAGE_KEY,
    tabId
  )

  return tabId
}

export const clearCustomerDisplayOwnerTabId = tabId => {
  const currentOwnerTabId = getCustomerDisplayOwnerTabId()

  if (!tabId || currentOwnerTabId === tabId) {
    globalThis.localStorage?.removeItem(
      CUSTOMER_DISPLAY_OWNER_TAB_ID_STORAGE_KEY
    )
  }
}

export const postCustomerDisplayMainMessage = (channel, message) => {
  channel?.postMessage({
    ...message,
    tabId: getCustomerDisplayTabId(),
  })
}

export const postCustomerDisplayTargetedMessage = (
  channel,
  message,
  targetTabId
) => {
  channel?.postMessage({
    ...message,
    source: CUSTOMER_DISPLAY_MESSAGE_SOURCE,
    ...(targetTabId && { targetTabId }),
  })
}

export const isCustomerDisplayMessageForCurrentTab = data =>
  !data?.targetTabId || data.targetTabId === getCustomerDisplayTabId()

export const isCustomerDisplaySourceMessage = data =>
  data?.source === CUSTOMER_DISPLAY_MESSAGE_SOURCE

export const getCustomerDisplayMessageOwnerTabId = data =>
  data?.ownerTabId || data?.tabId || null
